import { useLayoutEffect, useRef, useState } from 'react';
import * as st from './index.module.scss';

interface Props {
  text: string;
}

const Description = ({ text }: Props): JSX.Element => {
  const scrollToUp = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const [elementHeight, setElementHeight] = useState<number>(0);
  const elementRef = useRef<HTMLDivElement>(null);

  useLayoutEffect(() => {
    const calculateDynamicHeight = () => {
      if (elementRef.current) {
        const windowHeight = window.innerHeight;
        const elementPosition = elementRef.current.getBoundingClientRect().top;
        const calculatedHeight = windowHeight - elementPosition;
        setElementHeight(calculatedHeight);
      }
    };
    calculateDynamicHeight();

    scrollToUp();

    window.addEventListener('load', calculateDynamicHeight);
    window.addEventListener('resize', calculateDynamicHeight);

    return () => {
      window.removeEventListener('load', calculateDynamicHeight);
      window.removeEventListener('resize', calculateDynamicHeight);
    };
  }, []);

  return (
    <div
      className={st.main}
      ref={elementRef}
      style={{
        minHeight: `${elementHeight - 20}px`, // Устанавливаем вычисленную высоту
      }}
    >
      <section
        className={st.text}
        dangerouslySetInnerHTML={{
          __html: text ? text.replaceAll('\r', '</br>') : '',
        }}
      />
    </div>
  );
};

export default Description;
